import { Modal, ModalOptions } from "./Modal.js";

export interface NavigationOptions extends ModalOptions {

}

export class Navigation extends Modal {

    public create(options: NavigationOptions): this {
        super.create(options);

        e5.event.on(document.body, "click", `[data-action="openmenu"][aria-controls="${this.element.id}"]`, (e) => {
            this.show({
                fromHistory: false,
                initiator: e.target
            });
        });

        e5.event.on(this.element, "click", `[data-action]`, (e) => {
            if (document.activeElement && this.element.contains(document.activeElement)) {
                this.hide();
            }
        });

        return this;
    }
}